import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
let AbstractCalculator = /*#__PURE__*/_createClass(function AbstractCalculator() {
  _classCallCheck(this, AbstractCalculator);
});
export default AbstractCalculator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/util/calc/calculator.js
// module id = 976
// module chunks = 0